/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import frLocale from 'dayjs/locale/fr';
import dayjs from 'dayjs';
import { CalendarIcons } from '../../Utils/Images';
import { useTailwindBrand } from '../shared';
import { ENV_TEACHR } from '../../config/environment.config';

interface Props {
    getDate: ((value: string) => void) | undefined
    value: any
    maxDate?: any
    minDate?: any
    label?: string
    customDate?: string
    name?: string
    error?: boolean
    isCoursePass?: boolean
    errorMsg?: string
    startAt?: any
}

const calculateMinDate = (startAt: any) => {
    const today = dayjs();
    const firstDay = today.startOf('month');

    if (startAt && dayjs(startAt).isValid()) {
        const startDate = dayjs(startAt);
        return startDate.isAfter(firstDay) ? startDate : firstDay;
    }

    return firstDay;
};

const DateFields = (props: Props) => {
    const { brandConfig, classes, brand } = useTailwindBrand();
    const style = { backgroundColor: brandConfig.colors.background, borderRadius: '9.37px', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)', fontFamily: brandConfig.fontFamily };

    const initialDate = props.value ? dayjs(props.value) : null;
    const [date, setDate] = useState(initialDate);

    useEffect(() => {
        setDate(props.value ? dayjs(props.value) : null);
    }, [props.value]);

    useEffect(() => {
        const svg = document.querySelector('[data-testid = CalendarIcon]');
        if (svg) {
            svg.setAttribute("viewBox", "0 0 32 35");
        }
    }, []);

    const minDate = props?.minDate ? dayjs(props.minDate) : calculateMinDate(props?.startAt);

    return (
        <div className={`relative w-full ${props.customDate}`}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={frLocale}>
                <DesktopDatePicker
                    components={{ OpenPickerIcon: CalendarIcons }}
                    label={<span className={`${classes.fontFamily} font-bold`}>{props.label || "Date de naissance"}</span>}
                    defaultCalendarMonth={dayjs().subtract(16, 'year').month(0)}
                    inputFormat="DD/MM/YYYY"
                    minDate={minDate}
                    maxDate={props.maxDate ? dayjs(props.maxDate) : dayjs().add(2, "year")}
                    value={date}
                    orientation="landscape"
                    onChange={(newDate: any) => {
                        setDate(newDate);
                        props.getDate?.(newDate);
                    }}
                    renderInput={(params: any) => (
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            name={props.name || "date-input"}
                            className={`${classes?.input}`}
                            sx={{
                                backgroundColor: style?.backgroundColor || 'white',
                                borderRadius: style?.borderRadius || '0.375rem',
                                boxShadow: style?.boxShadow || '',
                                border: brand === ENV_TEACHR ? "" : '1px solid #E0E0E0',
                                '&.MuiTextField-root .MuiFilledInput-root': {
                                    fontFamily: brandConfig.fontFamily,
                                    background: 'transparent',
                                },
                                '&.MuiTextField-root label': {
                                    fontFamily: brandConfig.fontFamily,
                                    fontSize: '20px',
                                    color: '#000000',
                                },
                                '&.MuiTextField-root input': {
                                    fontFamily: brandConfig.fontFamily,
                                    fontSize: '16px',
                                    color: '#000000',
                                    height: '1.8em',
                                },
                            }}
                            fullWidth
                            variant="filled"
                            {...params}
                        />
                    )}
                />
            </LocalizationProvider>
            {props.error ? <strong className={`${classes.error} ${classes.fontFamily} lg:text-base italic`}>{props.errorMsg}</strong> : ""}
        </div>
    );
};

export default DateFields;
